export class RatingResponse{
    QuoteId:string;
    QuoteNumber: string; 
    errors: any;
    WWExposure: WWExposure;
  LimitPremiums: LimitPremiums[];    
}
export class LimitPremiums{
  LimitOfInsurance: number;
  FinalPremiums: FinalPremiums;
  Premiums: Premiums;
}
export class FinalPremiums {
    OneYearPremium: number;
    TwoYearPremium: number;
    ThreeYearPremium: number;  
    ThreeYearInsPremium: number;
  }
  export class Premiums{
    Base: number;
    MedEvac: number;
    ModBase: number;  
    ModLimit: number;
    WPV: number;  
}
export class WWExposure {
  TotalExposurePoints: number;
  }